(() => {
  const initHeader = (root = document) => {
    root.querySelectorAll('[data-cp-header]').forEach((header) => {
      if (header.dataset.cpReady) return;
      header.dataset.cpReady = 'true';
      const menus = [...header.querySelectorAll('.cp-menu, [data-cp-mobile-menu]')];
      const closeMenus = (except) => menus.forEach((menu) => {
        if (menu !== except) menu.open = false;
      });
      menus.forEach((menu) => menu.addEventListener('toggle', () => {
        if (menu.open) closeMenus(menu);
      }));
      header.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const opened = menus.find((menu) => menu.open);
        if (opened) {
          closeMenus();
          opened.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) closeMenus();
      });
      header.querySelector('[data-cp-language]')?.addEventListener('change', (event) => {
        event.target.form.requestSubmit();
      });
      header.querySelectorAll('.cp-mobile-menu__panel a').forEach((link) => {
        link.addEventListener('click', () => closeMenus());
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const count = event.cartData?.item_count;
          if (typeof count === 'number') header.querySelectorAll('[data-cp-cart-count]').forEach((label) => { label.textContent = count; });
        });
      }
    });
  };
  initHeader();
  document.addEventListener('shopify:section:load', (event) => initHeader(event.target));
  const chapters = document.querySelectorAll('.cp-chapter');
  if (chapters.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        document.querySelectorAll('.cp-chapter-nav a').forEach((link) => {
          if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      });
    }, { rootMargin: '-15% 0px -60% 0px' });
    chapters.forEach((chapter) => observer.observe(chapter));
  }
})();
